export default __webpack_public_path__ + "static/media/info-modal-warning.1394dee1.svg";